import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const EditIcon = ({ color = '#0d84fe', size = '40px', ...props }) => (
  <svg
    width={size}
    viewBox="0 0 20 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m13.98 2.922 3.131 3.172a.347.347 0 0 1 0 .485l-7.583 7.68-3.222.362a.68.68 0 0 1-.747-.756l.358-3.263 7.583-7.68a.336.336 0 0 1 .48 0zm5.624-.805L17.91.4a1.346 1.346 0 0 0-1.917 0l-1.23 1.245a.347.347 0 0 0 0 .485l3.133 3.172a.336.336 0 0 0 .479 0l1.23-1.245a1.388 1.388 0 0 0 0-1.941zm-6.27 10.053v3.58H2.221V4.497h7.98a.424.424 0 0 0 .295-.123l1.388-1.406c.264-.267.077-.721-.295-.721H1.667C.747 2.247 0 3.003 0 3.935v12.377C0 17.244.747 18 1.667 18h12.222c.92 0 1.667-.756 1.667-1.688v-5.549a.417.417 0 0 0-.712-.298l-1.39 1.406a.435.435 0 0 0-.12.299z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

EditIcon.propTypes = propTypes;

export default EditIcon;
